import { cooperplaceApi } from 'services/api';
import { normalizeFilters } from './contract';

/** Um registro por empresa em carg_user_definitions; os ids dos catálogos são da empresa. */
export const savedFiltersType = (companyId) => `control_tower_kanban_filters_${companyId}`;

/** Devolve os filtros salvos já normalizados, ou null quando não há registro válido. */
export async function readSavedFilters(companyId, signal) {
  const type = savedFiltersType(companyId);
  const { data } = await cooperplaceApi.get('/user/definitions', {
    params: { types: [type] },
    signal,
  });
  const row = Array.isArray(data) ? data.find((item) => item?.type === type) : null;
  if (typeof row?.definition !== 'string') return null;
  try {
    const saved = JSON.parse(row.definition);
    return saved?.version === 1 ? normalizeFilters(saved.filters) : null;
  } catch {
    // Registro de uma versão anterior do contrato: vale o padrão.
    return null;
  }
}

export function saveFilters(companyId, filters) {
  return cooperplaceApi.post('/user/definitions', {
    type: savedFiltersType(companyId),
    definition: JSON.stringify({ version: 1, filters }),
  });
}
